/* eslint-disable no-unused-vars */
import MKTypography from "components/MKTypography";
import PropTypes from "prop-types";

function SubTitleContents({ title, contents }) {
  return (
    <>
      <MKTypography variant="h3" mt={0} mb={3}>
        {title}
      </MKTypography>
      <MKTypography
        component="div"
        variant="body1"
        color="text"
        mb={2}
        sx={{ textAlign: "justify" }}
      >
        {contents}
      </MKTypography>
    </>
  );
}

SubTitleContents.propTypes = {
  title: PropTypes.string.isRequired,
  contents: PropTypes.node,
};

export default SubTitleContents;
